export default __webpack_public_path__ + "static/media/dashboard_user_circle.2686cc35.svg";